import { render, staticRenderFns } from "./ShoppingCartSalesTax.vue?vue&type=template&id=fc31e8aa&scoped=true"
import script from "./ShoppingCartSalesTax.vue?vue&type=script&lang=ts"
export * from "./ShoppingCartSalesTax.vue?vue&type=script&lang=ts"
import style0 from "./ShoppingCartSalesTax.vue?vue&type=style&index=0&id=fc31e8aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc31e8aa",
  null
  
)

export default component.exports